<template>
  <div>
  
    <b-card>
      <b-table 
        id="table-pdfs" :items="dataTable" :fields="fields" :per-page="perPage"
        :current-page="currentPage" responsive small fixed striped >
          <template #cell(establecimiento)="data">
              {{data.item.establecimiento? data.item.establecimiento.Descripcion : ""}}
          </template>
          <template #cell(usuario)="data">
              {{data.item.userDescargando? data.item.userDescargando : ""}}
          </template>
          <template #cell(estado)="data">
              <span v-if="data.item.descargar !== '2' && data.item.descargar !== '3'" > <b-spinner small type="grow"></b-spinner>
                  Generando..  </span>
              <label v-if="data.item.descargar === '2' || data.item.descargar === 2"> Cancelado </label>
              <label v-if="data.item.descargar === '3' || data.item.descargar === 3"> Finalizado </label>
          </template>
          <template #cell(doctor)="data">
              {{data.item.doctor? `${data.item.doctor.idPersona.primerNombre} ${data.item.doctor.idPersona.primerApellido}
              ` : "TODOS"}}
          </template>
          <template #cell(paciente)="data">
              {{data.item.paciente? `${data.item.paciente.persona.primerNombre} ${data.item.paciente.persona.primerApellido}` : "TODOS"}}
          </template>
          <template #cell(segurosalud)="data">
              <span> {{ getDescription(data.value, 'segurosalud') }}</span>
          </template>
          <template #cell(tipocobertura)="data">
              <span> {{ getDescription(data.value, 'tipocobertura') }}</span>
          </template>
          <template #cell(tiposervicio)="data">
              <span> {{ getDescription(data.value, 'tiposervicio') }}</span>
          </template>
          <template #cell(especialidad)="data">
              <span> {{ getDescription(data.value, 'dependencias') }}</span>
          </template>
          <template #cell(descarga)="data">
              <!-- <b-button :disabled = "estaDescargando" variant="primary" @click="downloadPdfs(index, item.id)" size="sm">
                  <i class="fas fa-download"></i>
              </b-button> -->
              <b-button v-if="data.item.rutaArchivo" variant="primary" @click="verCarpeta(data.item.rutaArchivo, data.item.id)" size="sm">
                  <i class="fas fa-download"></i>
              </b-button>
              <b-button title="Pacientes a descargar" variant="success" @click="downloadNombres(data.item.id)" size="sm">
                  <i class="fas fa-file"></i>
              </b-button>
          <b-button
            v-if="data.item.descargar !== '2'"
            title="Cancelar Descarga" 
            variant="danger" 
            @click="cancelarDescarga(data.item.id)" 
            size="sm"
          >
              <i class="fas fa-circle-xmark"></i>
          </b-button>
          </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataTable.length"
        :per-page="perPage"
        aria-controls="table-pdfs"
      ></b-pagination>
        
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import rutasrep from '@/assets/utils/rutas.json';
import { obtenerDataTablePdf } from "../services/archivosPdf";
import {
    loadEspecialidadesOpts,
    loadTipoSegurosOpts,
    loadTipoCoberturaOpts,
    loadTipoServiciosOpts
} from "../helpers";
import JSZip from "jszip";
import { v4 as uuidv4 } from 'uuid';
import { data } from 'jquery';
import { infoPacientesPdfsAGenerar } from "../services/archivosPdf";
export default {
    name: "PdfTableComponent",

    data() {
        return {
            timer : true,
            perPage: 6, // Número de filas por página
            currentPage: 1, // Página actual
            totalRows: 0, // Total de filas
            urlCarpeta : null,
            estaDescargando : false,
            dataTable: null,
            segurosSaludOpts: [],
            tipoCoberturaOpts: [],
            especialidadesOpts: [],
            tipoServicioOpts: [],
            progress: 0,
            progreso: null,
            isLoading: false,
            indexItem: null,
            archivozip: null,

            fields: [
               
                { key: "fechaproceso", label: "fecha/hora proceso", thClass: "text-center" },
                { key: "finicio", label: "desde", thClass: "text-center" },                
                { key: "ffin", label: "hasta", thClass: "text-center" },
                { key: "doctor", label: "doctor", thClass: "text-center" },
                { key: "paciente", label: "paciente", thClass: "text-center" },
                { key: "especialidad", label: "especialidad", thClass: "text-center" },
                { key: "segurosalud", label: "seguro", thClass: "text-center" },
                { key: "tipocobertura", label: "cobertura", thClass: "text-center" },
                { key: "tiposervicio", label: "servicio", thClass: "text-center" },
                { key: "usuario", label: "usuario", thClass: "text-center" },
                { key: "estado", label: "estado", thClass: "text-center" },
                { key: "descarga", label: "descarga", thClass: "text-center" },
            ],
        };
    },

    async created() {
        let dataTable = await obtenerDataTablePdf();
        console.log("data table", dataTable)
        //this.dataTable = dataTable.slice(0, 6);
        this.dataTable = dataTable
    
        await this.loadDataInitForm();
    },

    methods: {

        async downloadNombres(idArchivoPdf) {
    try {
        const responseInfo = await infoPacientesPdfsAGenerar(idArchivoPdf); // Obtiene la respuesta con el archivo base64

        if (responseInfo) {
            // Decodificar el base64 recibido
            const byteCharacters = atob(responseInfo); // Decodificamos el base64
            const byteArrays = [];

            // Convertir a un array de bytes
            for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
                const slice = byteCharacters.slice(offset, offset + 1024);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                byteArrays.push(new Uint8Array(byteNumbers));
            }

            // Crear el Blob para el archivo Excel
            const blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Crear un enlace para la descarga
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'pacientes_pdf_compilado.xlsx';  // Nombre del archivo

            // Simular el clic para iniciar la descarga
            link.click();
        } else {
            console.error('No se recibió base64 para el archivo');
        }
    } catch (error) {
        console.error('Error al descargar el archivo:', error);
    }
},

        
    async verCarpeta(url, idArchivoPdf) {

      if (idArchivoPdf) {
        
      }
      
      if (url) {
        
        const fullDownloadUrl = `${rutasrep.axiosrep}file/show/${url}`
        
        try {
          
          this.urlCarpeta = fullDownloadUrl
          window.open(fullDownloadUrl, '_blank');
          
        } catch (error) {
          this.$swal({
            title: 'Error',
            text: 'Un error ocurrio mientras descarga el archivo',
            icon: 'error',
            confirmButtonText: 'Entendido'
          });
      
        } 
      }else {
        this.$swal({
          title: 'Campos vacíos',
          text: 'El archivo no ha sido subido',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
      }
    },
        async loadDataInitForm() {
            this.segurosSaludOpts = await loadTipoSegurosOpts();
            this.tipoCoberturaOpts = await loadTipoCoberturaOpts();
            this.especialidadesOpts = await loadEspecialidadesOpts();
            this.tipoServicioOpts = await loadTipoServiciosOpts();
        },
        // async verificarDescargas(){
        // const query = `query MyQuery {
        //             viewOthersDownloadsPdfConsolidado {
        //                 id
        //                 userDescargando
        //                 establecimiento {
        //                 Descripcion
        //                 }
        //             }
        //             }`;
        // try {
               
        //        const response = await axios.post(rutasrep.axiosrep + 'api', { query });
        //        let respuesta = response.data.data.viewOthersDownloadsPdfConsolidado
        //        if (respuesta && respuesta.length > 0) {
        //             this.$swal.fire({
        //                 icon : "warning",
        //                 text : `Por favor espere, el Usuario: ${respuesta[0].userDescargando} ya esta procesando una descarga...`
        //             })
                   
        //            return true
        //        } else { return false}
        //    } catch (error) {
        //        console.log(error);
               
        //    }
        // },


    
    async cancelarDescarga(id){
      const query = `
        mutation MyMutation {
          detenerGeneracionPdf(idArchivoPdf: ${id}) {
            mensaje
            archivo {
              descargar
              id
            }
          }
        }
      `;
      try {

        const response = await axios.post(rutasrep.axiosrep + 'api', { query });
        if (response.data.data.detenerGeneracionPdf.mensaje === '200') {
          await this.$swal.fire({
            icon : "success",
            text : "Descarga detenida"
          })
          this.progress = 100;
          this.$router.go(0);
          return response.data.data.detenerGeneracionPdf.mensaje
        }
      } catch (error) {
        console.log(error);
      }
    },
   async obtenerProgresoTiempo(id){
        const progressInterval = setInterval(async () => {
            try {
                const response = await this.obtenerProgreso(id);
                const progreso = response?.data?.data?.obtenerProgresoPdf || 0;
                return progreso

            } catch (error) {
                console.error("Error obteniendo el progreso:", error);
                clearInterval(progressInterval); // Detener si ocurre un error
            }
        }, 4000); // Cada 4 segundos

    },

        async obtenerProgreso(id) {
            
            const query = `query MyQuery {
                obtenerProgresoPdf(idArchivoPdf: ${id})
                }`;
            try {
               

                const response = await axios.post(rutasrep.axiosrep + 'api', { query });
                if (response) {
                    return response.data.data.obtenerProgresoPdf
                }
            } catch (error) {
                console.log(error);
                
            }
        },

      
//     async downloadPdfs(index, id) {
//     // Verificar la hora actual
    
//     //const noDescargar = await this.verificarDescargas()
//     // if(noDescargar){
//     //     return
//     // }
   
  
//     this.estaDescargando = true
 

//     const query = `query MyQuery($id : ID!, $nameuser : String) {
//         generatePdfsArchivopdfs(idArchivoPdf : $id, nameuser : $nameuser) {
//             pdfBase64List
//             identificaciones
//             nombres
//         }
//     }`;
//     let nameuser = ''
//     const user = JSON.parse(localStorage.getItem('usuario'))
//     if(user){
//         nameuser = user.username
//     }
//     let establecimiento = ''
//     const detalleusuario = JSON.parse(localStorage.getItem('detalleusuario'))
//     if(detalleusuario){
//         establecimiento = detalleusuario.establecimiento?.Descripcion
//     }

//     const dataUser = nameuser + " - " + establecimiento
//     const variables = { id : id, nameuser : dataUser}
//     try {
//         this.indexItem = index;
//         this.isLoading = true;
//         this.progress = 0;

//         // Iniciar el intervalo para verificar el progreso
//         const progressInterval = setInterval(async () => {
//             try {
//                 const response = await this.obtenerProgreso(id);
//                 const progreso = response?.data?.data?.obtenerProgresoPdf || 0;
//                 this.progress = progreso;

//                 // Detener el intervalo si el progreso llega a 100
//                 if (this.progress >= 100) {
//                     clearInterval(progressInterval);
//                 }
//             } catch (error) {
//                 console.error("Error obteniendo el progreso:", error);
//                 clearInterval(progressInterval); // Detener si ocurre un error
//             }
//         }, 4000); // Cada 4 segundos

//         // Generar los PDFs
//         const response = await axios.post(rutasrep.axiosrep + 'api', { query : query, variables : variables });

//         // Si la generación del PDF es exitosa
//         if (response.status === 200) {
//             clearInterval(progressInterval); // Asegurar que se detenga el intervalo

//             this.progress = 100; // Establecer progreso al 100
//             this.estaDescargando = false
//             let data = response.data.data.generatePdfsArchivopdfs.pdfBase64List;
//             let identificaciones = response.data.data.generatePdfsArchivopdfs.identificaciones;
//             let nombres = response.data.data.generatePdfsArchivopdfs.nombres;

//             if (data.length > 0) {
//                 await this.generateZip(data, nombres, identificaciones);
//             } else {
//                 this.$swal({
//                     title: 'Info',
//                     text: 'No hay archivos para descargar',
//                     icon: 'warning',
//                     confirmButtonText: 'Entendido'
//                 });
//             }

//             this.isLoading = false; // Detener el indicador de carga
//         }
//     } catch (error) {
//         console.log(error);
//         this.isLoading = false;
//         this.progress = 0;
//     }
// }
// ,
        base64ToArrayBuffer(base64) {
            const binaryString = window.atob(base64); // Decodifica la cadena base64
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        },
      
        async generateZip(item, nombres, identificaciones) {
            
            
            const zip = new JSZip();

            for (let i = 0; i < item.length; i++) {
                const uuid = uuidv4();
                const contenidoPDF = this.base64ToArrayBuffer(item[i]);
                zip.file(`${identificaciones[i]}-${nombres[i]}-${uuid}.pdf`, contenidoPDF);
            }

            this.archivozip = await zip.generateAsync({ type: "base64" });

            const link = document.createElement('a');
            link.href = 'data:application/zip;base64,' + this.archivozip;
            link.download = 'archivos.zip';
            
            link.click();
        },

        getDescription(data, area) {
            if (data && area === 'segurosalud') {
                let esArreglo = this.esUnArreglo(data, this.segurosSaludOpts, true)
                
                if (!esArreglo) {
                    const foundItem = this.segurosSaludOpts.find(item => item.codigo === data);
                    return foundItem ? foundItem.text : "";
                }
                else {
                    return esArreglo
                }
            }
            if (data && area === 'tipocobertura') {
                let esArreglo = this.esUnArreglo(data, this.tipoCoberturaOpts, true)
                if (!esArreglo) {
                    const foundItem = this.tipoCoberturaOpts.find(item => item.codigo === data);
                    return foundItem ? foundItem.text : "";
                }
                else {
                    return esArreglo
                }
            }
            if (data && area === 'dependencias') {
                let esArreglo = this.esUnArreglo(data, this.especialidadesOpts, true)

                if (!esArreglo) {
                    const foundItem = this.especialidadesOpts.find(item => item.codigo === data);
                    return foundItem ? foundItem.text : "";
                } else {
                    return esArreglo
                }
            }
            if (data && area === 'tiposervicio') {
                let esArreglo = this.esUnArreglo(data, this.tipoServicioOpts)
                if (!esArreglo) {
                    const foundItem = this.tipoServicioOpts.find(item => item.value === data);
                    return foundItem ? foundItem.text : "";
                } else {
                    return esArreglo
                }
            }
            return "";
        },

        esUnArreglo(data, area, cod) {
            let datos = null
                        
            if (data.includes(",")) {
                datos = data.split(",").map(item => item.trim());
                console.log("entra aqui", data)
            }
            if (datos && cod ) {
                let info = []
                for (let i = 0; i < datos.length; i++) {
                    let foundinArray = area.find(item => item.codigo === datos[i]);
                    info.push(foundinArray.text)

                }
                console.log(info)
                info = info.join(", ")
                return info
            } else if (datos) {
                let info = []
                for (let i = 0; i < datos.length; i++) {
                    let foundinArray = area.find(item => item.value === datos[i]);
                    info.push(foundinArray.text)

                }
                console.log(info)
                info = info.join(", ")
                return info
            } else {
                return null
            }
            
        },

        

    },
    // watch: {
    // timer: {
    //     immediate: true,
    //     deep: true,
    //   async handler() {
    //     console.log("se ejecuta?")
    //     setInterval(async() => {
    //         this.dataTable = await obtenerDataTablePdf(); // Invertimos el valor de timer para activar el watch
    //         this.timer = !this.timer
    //     }, 30000); 
      
       
    //   }
      
    // }
//     dataTable: {
//     immediate: true,
//     deep: true,
//     async handler(newValue) {
//       if(newValue && newValue.length > 0){
//         try {
//         const dataUltima = newValue.slice(-15)
//         console.log("ESTA ES LA DATA DE LA TABLA", dataUltima)
        
//         dataUltima.forEach(async element => {
//             let progreso = await this.obtenerProgreso(element.id)
//             console.log("EL PDF CON ID", element.id, "PROGRESO DE", progreso)
//         });
//     } catch(error) {
//         console.log("error", error)
//     }

//     }
//   }
// }
//}
}
</script>